// Coluna Nota objetiva — exibe pontuação calculada e indicação de zero em área (desclassificação).

import React from 'react';
import { formatExamObjectiveScoreDisplay } from '../../utils/examObjectiveScoring';

export const ExamObjectiveScoreCell = React.memo(({ app, scoreMode }) => {
  const { primary, secondary, title } = formatExamObjectiveScoreDisplay(
    app?.exam_final_score,
    scoreMode,
    Boolean(app?.exam_objective_disqualified_zero)
  );
  return (
    <span title={title || undefined} style={{ display: 'inline-block', textAlign: 'center' }}>
      <span style={{ fontWeight: 600, display: 'block' }}>{primary}</span>
      {secondary ? (
        <span style={{ display: 'block', fontSize: 10, color: '#B91C1C', marginTop: 2, fontWeight: 600 }}>
          {secondary}
        </span>
      ) : null}
    </span>
  );
});
